<ng-container
  *appLet="{
    firstDateFromRange: firstDateFromRange$ | async,
    lastDateFromRange$: lastDateFromRange$ | async,
    isSkipped: isSkipped$ | async,
    isSingleDate: isSingleDate$ | async,
    culture: culture$ | async,
  } as $comp"
>
  <div class="date-range-picker-mobile">
    <div class="date-range-picker-mobile__input" (click)="onOpenMobileModal()">
      <app-svg-icon
        fill="voyage-blue"
        icon="calendar"
        [width]="16"
        [height]="16">
      </app-svg-icon>
      @if ($comp.isSkipped) {
        <span>{{ skipText }}</span>
      } @else if ($comp.firstDateFromRange) {
        <div class="date-range-picker-mobile__input_dates">
          <span>{{ $comp.firstDateFromRange.toJSDate() | date: DATE_FORMAT_DAY_SPACE_SHORT_MONTH_NAME : undefined : $comp.culture || FALLBACK_CULTURE }}</span>
          @if (!$comp.isSingleDate && $comp.lastDateFromRange$) {
            <app-svg-icon
              icon="chevron-right"
              [width]="16"
              [height]="16"
              stroke="gray-content-primary">
            </app-svg-icon>
            <span>{{ $comp.lastDateFromRange$.toJSDate() | date: DATE_FORMAT_DAY_SPACE_SHORT_MONTH_NAME : undefined : $comp.culture || FALLBACK_CULTURE }}</span>
          }
          </div>
      } @else {
        <span>{{ datePlaceholder }}</span>
      }
    </div>
  </div>
</ng-container>
